import { render, staticRenderFns } from "./ktvOrderList.vue?vue&type=template&id=3f2d799a&scoped=true"
import script from "./ktvOrderList.vue?vue&type=script&lang=ts"
export * from "./ktvOrderList.vue?vue&type=script&lang=ts"
import style0 from "./ktvOrderList.vue?vue&type=style&index=0&id=3f2d799a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d799a",
  null
  
)

export default component.exports